import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../../util/asyncComponent';

const TermsPolicy = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/terms/conditions`}/>

      <Route path={`${match.url}/conditions`} component={asyncComponent(() => import('./routes/Conditions'))}/>

      <Route path={`${match.url}/policies`} component={asyncComponent(() => import('./routes/Policies'))}/>
      
      <Route component={asyncComponent(() => import('../extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default TermsPolicy;